// Generated by scripts/generate_static_demo_mocks.py from data/backups/api-export/
// (real API responses captured from a dev company-router). Do not edit by hand.
// Real LLM answers to the tour's natural-language filter prompts, replayed
// verbatim: the demo answers any query on these processes with the canned
// narrowing instead of calling a model.
type FilterResponse = { explanation: string | null; instanceIds: string[] };

export const demoFilterResponses: Record<string, FilterResponse> = {
  "accounts-payable-exception-handling": {
    instanceIds: [
      "00058000-1db4-8283-b6f9-695f51d3d888:3",
      "00058000-1db4-8283-b6f9-695f51d3d888:4",
      "00058000-1db4-8283-b6f9-695f51d3d888:5",
      "00058000-1db4-8283-b6f9-695f51d3d888:8",
      "00058000-1db4-8283-b6f9-695f51d3d888:22",
      "00058000-1db4-8283-b6f9-695f51d3d888:26",
      "00058000-1db4-8283-b6f9-695f51d3d888:28",
      "00058000-1db4-8283-b6f9-695f51d3d888:34",
      "00058000-1db4-8283-b6f9-695f51d3d888:38",
      "00058000-1db4-8283-b6f9-695f51d3d888:55",
      "00058000-1db4-8283-b6f9-695f51d3d888:57",
      "00058000-1db4-8283-b6f9-695f51d3d888:60",
      "00058000-1db4-8283-b6f9-695f51d3d888:63",
      "00058000-1db4-8283-b6f9-695f51d3d888:67",
      "00058000-1db4-8283-b6f9-695f51d3d888:71",
      "00058000-1db4-8283-b6f9-695f51d3d888:74",
      "00058000-1db4-8283-b6f9-695f51d3d888:77",
      "00058000-1db4-8283-b6f9-695f51d3d888:79",
      "00058000-1db4-8283-b6f9-695f51d3d888:80",
      "00058000-1db4-8283-b6f9-695f51d3d888:81",
      "00058000-1db4-8283-b6f9-695f51d3d888:83",
      "00058000-1db4-8283-b6f9-695f51d3d888:85",
      "00058000-1db4-8283-b6f9-695f51d3d888:86",
      "00058000-1db4-8283-b6f9-695f51d3d888:95",
      "00058000-1db4-8283-b6f9-695f51d3d888:97",
      "00058000-1db4-8283-b6f9-695f51d3d888:101",
      "00058000-1db4-8283-b6f9-695f51d3d888:105",
      "00058000-1db4-8283-b6f9-695f51d3d888:108",
      "00058000-1db4-8283-b6f9-695f51d3d888:109",
      "00058000-1db4-8283-b6f9-695f51d3d888:110",
      "00058000-1db4-8283-b6f9-695f51d3d888:112",
      "00058000-1db4-8283-b6f9-695f51d3d888:118",
      "00058000-1db4-8283-b6f9-695f51d3d888:126",
      "00058000-1db4-8283-b6f9-695f51d3d888:133",
      "00058000-1db4-8283-b6f9-695f51d3d888:134",
      "00058000-1db4-8283-b6f9-695f51d3d888:139",
      "00058000-1db4-8283-b6f9-695f51d3d888:144",
      "00058000-1db4-8283-b6f9-695f51d3d888:145",
      "00058000-1db4-8283-b6f9-695f51d3d888:147",
    ],
    explanation:
      "Filtered instances where an invoice price variance (price mismatch between invoice and purchase order) is identified and processed, typically involving supplier contact and PO correction requests.",
  },
  "customer-service-case-resolution": {
    instanceIds: [
      "00058000-21d9-8b2b-85c3-225374f0b3e2:11",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:13",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:14",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:19",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:20",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:22",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:28",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:29",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:34",
      "00058000-21d9-8b2b-85c3-225374f0b3e2:37",
    ],
    explanation:
      "Sorted instances by total duration in descending order and selected the 10 with the longest processing times, ranging from 15m 41s down to 9m 32s.",
  },
};
